import { NumberOrNullOrUndefined, StringOrNullOrUndefined } from "src/app/shared/utils";

export const PAYROLL_NOTE_STATUSES = ['active', 'inactive'] as const;

export type PayrollNoteStatus = (typeof PAYROLL_NOTE_STATUSES)[number];

export const isPayrollNoteStatus = (
  value: unknown,
): value is PayrollNoteStatus =>
  PAYROLL_NOTE_STATUSES.includes(value as PayrollNoteStatus);

export class PayrollNote {
  id?: number;
  user_id?: number;
  vendor_id?: number;
  location_id?: number;
  date?: string;
  observations?: string;
  status?: PayrollNoteStatus;
  created_at?: Date | string;
  updated_at?: Date | string;
  deleted_at?: Date | string | null;

  static build = (data: Partial<PayrollNote>): PayrollNote => ({
    id: data.id ? NumberOrNullOrUndefined(data.id) : undefined,
    user_id: NumberOrNullOrUndefined(data.user_id),
    vendor_id: NumberOrNullOrUndefined(data.vendor_id),
    location_id: NumberOrNullOrUndefined(data.location_id),
    date: StringOrNullOrUndefined(data.date),
    observations: StringOrNullOrUndefined(data.observations),
    status: isPayrollNoteStatus(data.status) ? data.status : undefined,
    created_at: data.created_at ? new Date(data.created_at) : undefined,
    updated_at: data.updated_at ? new Date(data.updated_at) : undefined,
    deleted_at: data.deleted_at ? new Date(data.deleted_at) : null,
  });
}

export interface PayrollNotesListResponse {
  user_id: number;
  payroll_notes: PayrollNote[];
}
